<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点名称" prop="nodeName">
              <a-input placeholder="请输入节点名称" v-model="model.nodeName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点编码" prop="nodeCode">
              <a-input placeholder="请输入节点编码" v-model="model.nodeCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点表" prop="nodeTable">
              <a-input placeholder="请输入节点表" v-model="model.nodeTable"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="key字段" prop="keyCol">
              <a-input placeholder="请输入key字段" v-model="model.keyCol"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="title字段" prop="titleCol">
              <a-input placeholder="请输入title字段" v-model="model.titleCol"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父节点字段" prop="parentCol">
              <a-input placeholder="请输入父节点字段" v-model="model.parentCol"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父节点" prop="pid">
              <j-dict-select-tag
                :dictCode="
                  `
                  \`iwt-wf\`.common_treeview_config,nodeName,id,enabled=1 and tenant_id='${this.$ls.get('TENANT_ID')}'`
                "
                disabled="true"
                pageSize="9999"
                placeholder="父节点，默认为空"
                type="list"
                v-model="model.pid"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否生效" prop="enabled">
              <j-switch :options="[1, 0]" v-model="model.enabled"></j-switch>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点页面路由" prop="viewRoute">
              <a-input placeholder="请输入节点页面路由" v-model="model.viewRoute"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'CommonTreeviewConfigForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          enabled: 1
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          nodeName: [{ required: true, message: '请输入节点名称!' }],
          nodeCode: [{ required: true, message: '请输入节点编码!' }],
          nodeTable: [{ required: true, message: '请输入节点表!' }],
          keyCol: [{ required: true, message: '请输入key字段!' }],
          titleCol: [{ required: true, message: '请输入title字段!' }],
          enabled: [{ required: true, message: '请输入是否生效!' }],
          viewRoute: [{ required: true, message: '请输入节点页面路由!' }]
        },
        url: {
          add: '/custom/treeview/add',
          edit: '/custom/treeview/edit',
          queryById: '/custom/treeview/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      }
    }
  }
</script>
